module.exports = __webpack_public_path__ + "img/窄边.7f336d61.webp";